export const industryContent = {
  transport: {
    title: 'Transport & Logistics',
    description:
      'Comprehensive fleet management and logistics optimization platform designed for transport companies, courier services, and logistics providers. Streamline operations from dispatch to delivery.',
    features: [
      'Real-time GPS tracking for entire fleet with live location updates',
      'Automated route optimization to reduce fuel costs and delivery times',
      'Driver management with performance metrics and compliance tracking',
      'Maintenance scheduling and vehicle health monitoring',
      'Load planning and capacity optimization',
      'Electronic proof of delivery (ePOD) with photo capture',
      'Fuel consumption analytics and cost tracking',
      'Integration with telematics and IoT devices',
    ],
    benefits: [
      'Reduce fuel costs by 15-25%',
      'Improve on-time delivery rates',
      'Lower vehicle maintenance costs',
      'Increase fleet utilization',
      'Enhance driver safety and compliance',
      'Real-time customer notifications',
    ],
    useCases: [
      'Last-mile delivery optimization',
      'Long-haul freight management',
      'Multi-stop route planning',
      'Temperature-controlled transport',
    ],
  },
  shipping: {
    title: 'Shipping & Freight',
    description:
      'End-to-end shipping and freight management solution for international trade, port operations, and cargo handling. Manage complex global supply chains with ease.',
    features: [
      'Container tracking across multiple carriers and ports',
      'Automated customs documentation and compliance',
      'Bill of lading generation and management',
      'Port scheduling and berth allocation',
      'Freight rate management and quotation system',
      'Cargo insurance tracking and claims management',
      'Multi-modal transport coordination (sea, air, rail, road)',
      'Real-time shipment visibility for customers',
    ],
    benefits: [
      'Reduce documentation errors by 90%',
      'Faster customs clearance',
      'Improved cargo visibility',
      'Lower demurrage and detention costs',
      'Better carrier relationship management',
      'Streamlined claims processing',
    ],
    useCases: [
      'International freight forwarding',
      'Port terminal operations',
      'Customs brokerage',
      'Break-bulk cargo handling',
    ],
  },
  hospitality: {
    title: 'Hospitality Management',
    description:
      'All-in-one property management system for hotels, resorts, and vacation rentals. Deliver exceptional guest experiences while optimizing operations and revenue.',
    features: [
      'Central reservation system with channel manager integration',
      'Front desk operations and check-in/check-out automation',
      'Housekeeping management with room status tracking',
      'Guest profile management and preference tracking',
      'Dynamic pricing and revenue management',
      'Point of sale integration for restaurants and spa',
      'Loyalty program management',
      'Mobile app for guest services and requests',
    ],
    benefits: [
      'Increase direct bookings by 30%',
      'Improve guest satisfaction scores',
      'Optimize room pricing and occupancy',
      'Reduce operational costs',
      'Streamline staff workflows',
      'Enhance upselling opportunities',
    ],
    useCases: [
      'Boutique hotel management',
      'Resort operations',
      'Vacation rental management',
      'Conference and event venues',
    ],
  },
  retail: {
    title: 'Retail Operations',
    description:
      'Omnichannel retail management platform for single and multi-location stores. Unify your online and offline sales channels for seamless customer experiences.',
    features: [
      'Multi-location inventory synchronization in real-time',
      'Point of sale with offline mode capability',
      'E-commerce integration (Shopify, WooCommerce, Magento)',
      'Customer loyalty and rewards program',
      'Purchase order management and supplier portal',
      'Barcode scanning and label printing',
      'Sales analytics and product performance tracking',
      'Employee management with commission tracking',
    ],
    benefits: [
      'Eliminate stockouts and overstock',
      'Increase sales per square foot',
      'Improve inventory turnover',
      'Reduce shrinkage and theft',
      'Better customer retention',
      'Faster checkout times',
    ],
    useCases: [
      'Fashion and apparel retail',
      'Electronics and gadgets',
      'Grocery and convenience stores',
      'Specialty retail chains',
    ],
  },
  automobile: {
    title: 'Automobile Dealership',
    description:
      'Complete dealership management system for automotive sales and service centers. Manage inventory, sales pipeline, service appointments, and parts all in one platform.',
    features: [
      'Vehicle inventory management with VIN tracking',
      'Sales pipeline and lead management',
      'Test drive scheduling and tracking',
      'Finance and insurance product integration',
      'Service appointment booking and reminders',
      'Parts inventory and ordering system',
      'Warranty tracking and claims management',
      'Customer communication and follow-up automation',
    ],
    benefits: [
      'Increase vehicle sales conversion',
      'Improve service department revenue',
      'Better parts inventory management',
      'Enhanced customer retention',
      'Streamlined finance processes',
      'Higher customer satisfaction',
    ],
    useCases: [
      'New car dealerships',
      'Used car lots',
      'Service and repair centers',
      'Auto parts retailers',
    ],
  },
  manufacturing: {
    title: 'Manufacturing & Production',
    description:
      'Production planning and supply chain coordination platform for manufacturers. Optimize your production processes from raw materials to finished goods.',
    features: [
      'Production scheduling and capacity planning',
      'Bill of materials (BOM) management',
      'Work order tracking and shop floor control',
      'Quality control and inspection workflows',
      'Raw material procurement and supplier management',
      'Warehouse management with bin locations',
      'Equipment maintenance scheduling',
      'Production cost tracking and analysis',
    ],
    benefits: [
      'Reduce production lead times',
      'Minimize waste and scrap',
      'Improve product quality',
      'Better resource utilization',
      'Lower inventory carrying costs',
      'Enhanced supplier relationships',
    ],
    useCases: [
      'Discrete manufacturing',
      'Process manufacturing',
      'Assembly operations',
      'Job shop production',
    ],
  },
}
